module.exports={
	"Test":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"Hash":
			{
				"Hash": "Hash",
				"Name": "Hash"
			}
		}
	},
	"Document":
	{
		"Descriptors":
		{
			"DocumentDate_Formatted":
			{
				"Hash": "DocumentDate_Formatted",
				"Name": "Date",
				"DataType": "DateTime"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Creator"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"StateName":
			{
				"Hash": "StateName",
				"Name": "Status Info"
			}
		}
	},
	"Project":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"Description":
			{
				"Hash": "Description",
				"Name": "Description"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_Organization":
			{
				"Hash": "_Organization",
				"Name": "Contractor"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"ContractedDays":
			{
				"Hash": "ContractedDays",
				"Name": "Contracted Days",
				"DataType": "PreciseNumber"
			},
			"InitialContractAmount_Formatted":
			{
				"Hash": "InitialContractAmount",
				"Name": "Initial Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractAmount_Formatted":
			{
				"Hash": "CurrentTotalContractAmount",
				"Name": "Current Total Contract Amount",
				"DataType": "PreciseNumber"
			},
			"CurrentTotalContractPaid_Formatted":
			{
				"Hash": "CurrentTotalContractPaid",
				"Name": "Current Total Contract Paid",
				"DataType": "PreciseNumber"
			}
		}
	},
	"TestInstance":
	{
		"Descriptors":
		{
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Test":
			{
				"Hash": "_Test",
				"Name": "Test"
			},
			"_Lab":
			{
				"Hash": "Lab",
				"Name": "Lab"
			},
			"Status":
			{
				"Hash": "Status",
				"Name": "Status"
			},
			"TestResult":
			{
				"Hash": "TestResult",
				"Name": "Test Result"
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By"
			}
		}
	},
	"LineItem": 
	{
		"Descriptors":
		{
			"ItemCode":
			{
				"Hash": "ItemCode",
				"Name": "Item Code"
			},
			"ItemNumber":
			{
				"Hash": "ItemNumber",
				"Name": "Item Number"
			},
			"Name":
			{
				"Hash": "Name",
				"Name": "Name"
			},
			"_Project":
			{
				"Hash": "_Project",
				"Name": "Project"
			},
			"_Contract":
			{
				"Hash": "_Contract",
				"Name": "Contract"
			},
			"_BidItem":
			{
				"Hash": "_BidItem",
				"Name": "Bid Item"
			},
			"_PayItem":
			{
				"Hash": "_PayItem",
				"Name": "Pay Item"
			},
			"ContractQuantity_Formatted":
			{
				"Hash": "ContractQuantity_Formatted",
				"Name": "Contract Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ChangeOrderQuantity_Formatted":
			{
				"Hash": "ChangeOrderQuantity_Formatted",
				"Name": "Change Order Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ExpectedQuantity_Formatted":
			{
				"Hash": "ExpectedQuantity_Formatted",
				"Name": "Expected Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"ActualQuantity_Formatted":
			{
				"Hash": "ActualQuantity_Formatted",
				"Name": "Actual Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"InstalledQuantity_Formatted":
			{
				"Hash": "InstalledQuantity_Formatted",
				"Name": "Installed Quantity",
				"DataType": "PreciseNumber",
				"HeadlightSummary":
				{
					"DecimalPrecision": 2
				}
			},
			"CreateDate_Formatted":
			{
				"Hash": "CreateDate_Formatted",
				"Name": "Created On",
				"DataType": "DateTime",
				"HeadlightSummary":
				{
					"DateFormat": "YYYY-MM-DD"
				}
			},
			"_CreatingUser":
			{
				"Hash": "_CreatingUser",
				"Name": "Created By",
				"HeadlightSummary":
				{
					"DisplayFields": ["NameFirst", "NameLast"]
				}
			}
		}
	}
}
